<template>
<div class="focused-panel">
  <div class="d-flex polytron-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>
  </div>

  <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm">
    <div slot="modal-header">
      <label>{{formTitle}}</label>
      <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div>
    </div>
    <div class="p-2">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Asset Tag:">
              <b-form-input id="unique-id" :disabled="featureLock" v-model="wellAttrs['asset_tag']" placeholder="Enter tag"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Infrastructure Type:">
              <b-form-select :disabled="featureLock" :options="infrastructure_type_options" v-model="wellAttrs['infrastructure_type']" required placeholder="Please, select option" v-b-tooltip.hover></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Status:">
              <b-form-select :disabled="featureLock" :options="status_options" v-model="wellAttrs['status']" required placeholder="Please, select option" v-b-tooltip.hover></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Stage:">
              <b-form-select :disabled="featureLock" :options="stage_options" v-model="wellAttrs['stage']" required placeholder="Please, select option" v-b-tooltip.hover></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Revision:">
              <b-form-input id="revision" :disabled="featureLock" v-model="wellAttrs['revision']" placeholder="Enter revision"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Description:" label-for="description">
              <b-textarea id="description" :disabled="featureLock" v-model="wellAttrs['description']"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col >
            <span class="batch-title">Projects:</span>
            <div class='batch-container'>
              <b-row v-for="batch in batch_zones" :key="'batch'+batch.value">
                <b-col>
                  <b-form-group class='batch-project'>
                    <b-form-checkbox v-model="batch.selected">{{batch.text}}</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div slot="modal-footer" class="designatron-modal-footer">
      <b-row>
        <b-col>
          <div role="group" class="btn-group">
            <b-btn size="sm" class="float-right" variant="primary" @click="close">
              Close
            </b-btn>
            <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onSaveCheck">
              Save
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</div>
</template>

<script>
import 'vue-awesome/icons/arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/check'
import Vue from 'vue'

import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import uuidV1 from 'uuid/v1'

export default {
  name: 'facility-common-infrastucture',
  mixins: [FeatureEditorMixin],
  data() {
    return {
      markLastModified: false,
      featureId: null,
      addPolyEnabled: false,
      addLineEnabled: false,
      addPointEnabled: false,
      wellAttrs: {
        description: '',
        project_name: null,
        infrastructure_type: null,
        asset_tag: null,
        stage: 'Concept',
        status: 'Current',
        revision: null
      },
      wellLayerName: 'v4:facilities_commoninfrastructure',
      geometryName: 'geo',
      idName: 'id',
      geomType: 'Polygon',
      identName: 'asset_tag',
      lockable: true,
      status_options: ['Cancelled', 'Current', 'Superseded'],
      stage_options: ['Concept', 'IFAAS', 'IFAWP', 'IFSSc', 'IFSA', 'RFS',
        'IFD', 'IFR', 'IFC', 'Preliminary As-Built', 'As-Built', 'Commissioned',
        'Rehabilitated', 'Decommissioned'],
      infrastructure_type_options: [
        {text: 'Borrow Pit', value: 0},
        {text: 'Building', value: 1},
        {text: 'Camp - Construction', value: 2},
        {text: 'Camp - Mobile Drilling', value: 3},
        {text: 'Camp - Operation', value: 4},
        {text: 'CGPF', value: 5},
        {text: 'Communication Tower', value: 6},
        {text: 'CPP', value: 7},
        {text: 'Depot', value: 8},
        {text: 'FCS', value: 9},
        {text: 'Flare', value: 10},
        {text: 'Gravel Pit', value: 11},
        {text: 'Inlet Facility', value: 12},
        {text: 'Irrigation Area', value: 13},
        {text: 'Laydown - Central', value: 14},
        {text: 'Laydown - Local', value: 15},
        {text: 'Metering Skid - Gas', value: 16},
        {text: 'Metering Skid - Water', value: 17},
        {text: 'Metering Station', value: 18},
        {text: 'Mud Pit', value: 19},
        {text: 'Office', value: 20},
        {text: 'Other', value: 21},
        {text: 'Parking', value: 22},
        {text: 'Pipe Yard', value: 23},
        {text: 'Power', value: 24},
        {text: 'Power Station', value: 25},
        {text: 'Pump Station', value: 26},
        {text: 'Quarry', value: 27},
        {text: 'Receiver Compound', value: 28},
        {text: 'Sediment Pond', value: 29},
        {text: 'Shed', value: 30},
        {text: 'Silo', value: 31},
        {text: 'Site Office', value: 32},
        {text: 'Spoil', value: 33},
        {text: 'Stockpile', value: 34},
        {text: 'Storage', value: 35},
        {text: 'Sub-station', value: 36},
        {text: 'Weather Station', value: 37},
        {text: 'Water Storage', value: 38},
        {text: 'WTF', value: 39},
        {text: 'WTS', value: 40}
      ],
      batch_zones: [],
      hoverLock: false,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters['project/currentProject']
    }
  },
  methods: {
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    },
    onSaveCheck(evt) {
      let selected_zones = []

      this.batch_zones.forEach(z => {
        if (z.selected) {
          selected_zones.push(z.text)
        }
      })
      this.wellAttrs['project_name'] = selected_zones.join(', ')
      this.onOK(evt)
    },
    loadBatchZones() {
      this.batch_zones = []
      this.$http.get('/api/layers/get-batch-zones', {
        params: {
          workpack_id: this.currentProject.workpack.id
        }
      }).then(res => {
        let x = []
        res.body.forEach(t =>
          x.push({
            text: t.batch_name,
            value: t.gid,
            selected: false
          })
        )
        if (x.length) {
          this.selected_batch_zone = x[0].value
          x.sort(function(a, b) {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          })
        }
        this.initial_batch_zones = x
        this.batch_zones = x.map(a => {return {...a}})

        let zones
        if (this.wellAttrs['project_name'].length > 1) {

          zones = this.wellAttrs['project_name'].split(', ')
        } else {
          zones = []
        }

        zones.forEach(z => {
          this.batch_zones.find(b => {
            if (b.text === z) {
              b.selected = true
            }
          })
        })
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load batch zones',
          type: 'error'
        })
      })
    }
  },
  watch: {
    showForm (val) {
      if (val) {
        this.loadBatchZones()
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/FacilityCommonInfrastucture.vue